import service from '@/utils/request'

export function commodityClassificationList(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodityClassification/commodityClassificationList',
        data: param
    })
}

export function commodityClassificationListAll() {
    return service.request({
        method: 'POST',
        url: '/app/commodityClassification/list',
    })
}

export function addBasicClassify(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodityClassification/add',
        data: param
    })
}

export function editBasicClassify(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodityClassification/edit',
        data: param
    })
}

export function batchDelBasicClassify(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodityClassification/batchDel',
        data: param
    })
}


export function delBasicClassify(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodityClassification/del',
        data: param
    })
}

export function exportBasicClassify(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodityClassification/export',
        data: param
    })
}

export function queryByParentId(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodityClassification/queryByParentId',
        data: param
    })
}


